module.exports = __webpack_public_path__ + "img/shoe-bottom.4b3ae6d1.png";